export default{
    methods: {
        camelCase: function(str) {
          str = str.charAt(0).toLowerCase() + str.slice(1);
          return str.replace(/[-_](.)/g, function(match, group1) {
              return group1.toUpperCase();
          });
        },

        snakeCase: function(str){
          var camel = this.camelCase(str);
          return camel.replace(/[A-Z]/g, function(s){
            return "_" + s.charAt(0).toLowerCase();
          });
        },

        pascalCase: function(str){
          var camel = this.camelCase(str);
          return camel.charAt(0).toUpperCase() + camel.slice(1);
        },

        // エラー表示をすべてクリアする
        clearErrors: function(_name) {
            $('.c-error').each(function(index, object){
                let errorElement = $(object);

                // vueでエラーメッセージを管理している目印の特定クラス名が付与されている場合は処理スキップ
                if (errorElement.hasClass('vc-zf35gktmw6')) {
                    return;
                }

                errorElement.removeClass('is-active');
                if (errorElement.attr('data-error-anchor')) {
                    errorElement.css('right', '');
                }
                let text = errorElement.find('.c-error__text')
                if(text[0]){
                    text.text('');
                }
            });
            $('.c-input,.c-select,.c-textarea,.c-select-time,.c-select-week,.c-select-week-time').each(function (index, object) {
                let element = $(object);

                // vueでエラーメッセージを管理している目印の特定クラス名が付与されている場合は処理スキップ
                if (element.hasClass('vc-zf35gktmw6')) {
                    return;
                }

                element.removeClass('is-error');
            });
        },

        // input要素 の近くにある .c-error 要素を取得する
        findErrorElement: function(inputName) {
            let error = null;
            let input = $('input[name=' + inputName + ']');
            if(input.length == 0){
                input = $('textarea[name=' + inputName + ']');
            }
            if(input[0]){
                let parent = input.parent();
                if(parent[0]){
                    error = parent.find('.c-error');
                }
                // c-error を持つ要素まで移動
                while(parent[0] && !error[0]){
                    parent = parent.parent();
                    if(parent[0]){
                        error = parent.find('.c-error')
                    }
                }
            }
            return error;
        },

        // エラー表示をすべてクリアする
        clearErrorByTargetElement: function(el) {
            el.classList.remove('is-error');
            el.querySelector('.c-error').classList.remove('is-active');
            // console.log(el)
            // console.log(el.classList)
            // console.log()
            // console.log(el.querySelector('.c-errora')) // null
        },

        // エラーメッセージ要素の先祖に c-input クラスがあれば is-error クラスを追加する
        markError: function(errorElement) {
            let parent = errorElement.parent();
            while(
                parent[0] &&
                !parent.hasClass('c-input') &&
                !parent.hasClass('c-select') &&
                !parent.hasClass('c-textarea') &&
                !parent.hasClass('c-select-time') &&
                !parent.hasClass('c-select-week') &&
                !parent.hasClass('c-select-week-time')
            ) {
                parent = parent.parent();
            }

            if(
                parent[0] &&
                (
                    parent.hasClass('c-input') ||
                    parent.hasClass('c-select') ||
                    parent.hasClass('c-textarea') ||
                    parent.hasClass('c-select-time') ||
                    parent.hasClass('c-select-week') ||
                    parent.hasClass('c-select-week-time')
                )
            ) {
                parent.addClass('is-error');
            }
        },

        // data-error-anchor指定時、兄弟要素の位置を基準にバルーンを配置する
        adjustErrorAnchor: function(errorElement) {
            var anchor = errorElement.attr('data-error-anchor');
            if (!anchor) return;
            var parent = errorElement.parent();
            var sibling = parent.find('.' + anchor);
            if (!sibling[0] || !parent[0]) return;
            var parentRight = parent[0].getBoundingClientRect().right;
            var siblingRight = sibling[0].getBoundingClientRect().right;
            var offset = parentRight - siblingRight;
            errorElement.css('right', offset + 'px');
        },

        // エラーメッセージを表示する
        showErrors: function(errors) {
            this.clearErrors();
            for (let elementName in errors) {
                let message = errors[elementName];
                if(message != null){
                    let errorElement = this.findErrorElement(elementName);

                    // vueでエラーメッセージを管理している目印の特定クラス名が付与されている場合は処理スキップ
                    if (errorElement != null && errorElement.hasClass('vc-zf35gktmw6')) {
                        continue;
                    }

                    if(errorElement != null){
                        if(errorElement[0]){
                            errorElement.addClass('is-active');
                            let text = errorElement.find('.c-error__text')
                            if(text[0]){
                                text.text(message);
                            }
                            this.markError(errorElement);
                            this.adjustErrorAnchor(errorElement);
                        }
                    }
                }
            }
        },

        // ノーマルレスポンスの処理、result が OK なら true それ以外は false を返す
        handleResponse: function(response, isShowError) {
            let success = false;
            if(response.data != null){
                if(response.data.result == 'OK'){
                    success = true;
                } else {
                    //
                    // レスポンスにエラー情報がある場合
                    // 第2引数のエラー表示フラグがtrueか、設定されていない場合 (デフォルトの挙動)はエラーを表示
                    //
                    // TODO: jqueryでdom操作してエラーを表示するとvuejsで上手くクリアできなくなるため、最終的には全てvuejsで行う
                    //
                    if(
                        response.data.errors &&
                        (typeof isShowError == 'undefined' || isShowError == true)
                    ){
                        this.showErrors(response.data.errors);
                    }
                }
            }
            return success;
        },

        // HTTPエラーの処理
        handleHttpError: function(error) {
            if(error.response) {
                // 権限がない場合はログイン画面へ遷移
                if(error.response.status == 401){
                    location.href = "/coins-admin";
                    return;
                }
            }
            // alert('予期せぬエラーが発生しました');
        },

        // 直前のページに戻る
        backToPreviousPage: function() {
            history.back();
        },

        // yyyy-mm-dd hh:mm:ss を yyyy/mm/dd に変換
        getDisplayDate: function(dateTimeString) {
            let dateString = '';
            if(dateTimeString){
                dateString = dateTimeString.replace(/-/g, '/').substr(0,10);
            }
            return dateString;
        },

        // yyyy-mm-dd hh:mm:ss を hh:mm に変換
        getDisplayTime: function(dateTimeString) {
            let timeString = '';
            if(dateTimeString){
                timeString = dateTimeString.substr(11,5);
            }
            return timeString;
        },

        // yyyy-mm-dd hh:mm:ss を yyyy/mm/dd hh:mm に変換
        getDisplayDateTime: function(dateTimeString) {
            return this.getDisplayDate(dateTimeString) + ' ' + this.getDisplayTime(dateTimeString);
        },

        getDateStringFromDateObject: function(dateObject) {
            let year = '' + dateObject.getFullYear();
            let month = '' + (dateObject.getMonth() + 1);
            month = month.padStart(2, '0');
            let day = '' + dateObject.getDate();
            day = day.padStart(2, '0');

            let dateString = year + '-' + month + '-' + day;
            return dateString;
        },

        checkboxToQuery: function(checkboxModel,name) {
            var str = [];
            for (let index in checkboxModel) {
                let value = checkboxModel[index];
                str.push(encodeURIComponent(name) + "[]=" + encodeURIComponent(value));
            }
            return str.join("&");
        },

        getTopicConditionDetailTypeString: function(topicConditionDetail) {
            let typeString;
            if(topicConditionDetail.data_type == 'sex'){
                typeString = '性別';
            } else if(topicConditionDetail.data_type == 'age'){
                typeString = '年齢';
            } else if(topicConditionDetail.data_type == 'pref'){
                typeString = '地域';
            } else if(topicConditionDetail.data_type == 'interest'){
                typeString = '興味';
            } else if(topicConditionDetail.data_type == 'keyword'){
                typeString = 'キーワード';
            } else if(topicConditionDetail.data_type == 'pref_detail'){
                typeString = '都道府県';
            } else if(topicConditionDetail.data_type == 'company') {
                typeString = '企業';
            } else {
                typeString = topicConditionDetail.data_type;
            }
            return typeString;
        },

        getTopicConditionDetailValueString: function(topicConditionDetail) {
            let valueString;
            if(topicConditionDetail.data_type == 'sex'){
                valueString = topicConditionDetail.condition_1;
            } else if(topicConditionDetail.data_type == 'age'){
                valueString = topicConditionDetail.condition_1 + '歳-' + topicConditionDetail.condition_2 + '歳';
            } else if(topicConditionDetail.data_type == 'pref'){
                valueString = topicConditionDetail.condition_1;
            } else if(topicConditionDetail.data_type == 'interest'){
                valueString = topicConditionDetail.condition_1;
            } else if(topicConditionDetail.data_type == 'keyword'){
                valueString = topicConditionDetail.condition_1;
            } else if (topicConditionDetail.data_type == 'company'){
                let values = {'1': '企業ユーザー'};
                valueString = values[topicConditionDetail.condition_1];
            } else {
                valueString = topicConditionDetail.condition_1;
            }
            return valueString;
        },

        // 時刻データが正しいかどうか判定
        timeIsValid: function(value) {
            let valid = false;
            if(value){
                if (typeof value === 'object') {
                    const regex = /^[0-9]{2}$/;
                    if(value.HH.match(regex) && value.mm.match(regex)){
                        valid = true;
                    }
                } else if (typeof value === 'string') {
                    const regex = /^[0-9]{2}:[0-9]{2}$/;
                    if(value.match(regex)){
                        valid = true;
                    }
                }
            }
            return valid;
        },

    }
}
